import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  linhVuc: Yup.object()
    .shape({
      id: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required),
  app: Yup.object()
    .shape({
      id: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required),
  role: Yup.object()
    .shape({
      id: Yup.string()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required)
});
